<template>
  <div>
        <div class="chat-sidebar">
            <div class="chat-sidebar-top">
                <button class="sidebarNewBtn" @click="showMsgModals()">New Message</button>
            </div>
            <div class="chat-sidebar-sarch">
                <button type="submit">
                    <img alt="commaful-logo" src="../../assets/images/Search-Icon.svg" />
                </button>
                <input type="text" placeholder="Search messages, name, or group">
            </div>
            <div class="chat-sidebar-markRead">
                <button type="button">Mark all messages as read</button>
                <button type="button">
                    <img alt="commaful-logo" src="../../assets/images/trash.svg" />
                </button>
            </div>

            <div class="chat-sidebar-tabs">
                <ul class="nav nav-tabs nav-justified">
                  <li class="nav-item">
                    <a class="nav-link" @click.prevent="setActive('direct')" :class="{ active: isActive('direct') }" href="#direct">DIRECT</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" @click.prevent="setActive('groups')" :class="{ active: isActive('groups') }" href="#groups">GROUPS</a>
                  </li>
                </ul>
            </div>

            <div class="tab-content py-3" id="chat-sidebar-list-wrap">
              <div class="tab-pane fade" :class="{ 'active show': isActive('direct') }" id="home">
                <direct-chat-list :windowSize="window.width"></direct-chat-list>
              </div>
              <div class="tab-pane fade" :class="{ 'active show': isActive('groups') }" id="profile">
                  <group-chat-list :windowSize="window.width"></group-chat-list>
              </div>
            </div>
        </div>

        <!-- message modal start -->
        <modal v-if="msgModal" @close="msgModal = false" class="importText empty-msg-mdl">
            <div slot="modalFixed">
                Lorem ipsum dolor sit amet
            </div>
            <div slot="closeModal" class="x-msg-mdl-cls" @click="msgModal = false">
               <img alt="commaful-logo" src="../../assets/images/x.png" />
            </div>
            <div slot="header">

                <div class="searchFriendInModal">
                   <input type="test" placeholder="Find your friends" >
                   <img alt="commaful-logo" src="../../assets/images/Search.png" />
               </div>
               
            </div>
            <div slot="body">
              <ul class="profileModal">
                  <li>
                      <router-link to="/chat-details/2" class="profileModalItem" @click="msgModal==false">
                          <div class="modalProImg">
                                <img alt="commaful-logo" src="../../assets/images/f1.png" />
                          </div>
                          <div class="modalProDesc">
                                <h3>Neville Griffin</h3>
                                <p>@nevilleg</p>
                          </div>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/chat-details/3" class="profileModalItem" @click="msgModal==false">
                          <div class="modalProImg">
                                <img alt="commaful-logo" src="../../assets/images/f1.png" />
                          </div>
                          <div class="modalProDesc">
                                <h3>Neville Griffin</h3>
                                <p>@nevilleg</p>
                          </div>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/chat-details/1" class="profileModalItem" @click="msgModal==false">
                          <div class="modalProImg">
                                <img alt="commaful-logo" src="../../assets/images/f1.png" />
                          </div>
                          <div class="modalProDesc">
                                <h3>Neville Griffin</h3>
                                <p>@nevilleg</p>
                          </div>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/chat-details/1" class="profileModalItem" @click="msgModal==false">
                          <div class="modalProImg">
                                <img alt="commaful-logo" src="../../assets/images/f1.png" />
                          </div>
                          <div class="modalProDesc">
                                <h3>Neville Griffin</h3>
                                <p>@nevilleg</p>
                          </div>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/chat-details/1" class="profileModalItem" @click="msgModal==false">
                          <div class="modalProImg">
                                <img alt="commaful-logo" src="../../assets/images/f1.png" />
                          </div>
                          <div class="modalProDesc">
                                <h3>Neville Griffin</h3>
                                <p>@nevilleg</p>
                          </div>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/chat-details/1" class="profileModalItem" @click="msgModal==false">
                          <div class="modalProImg">
                                <img alt="commaful-logo" src="../../assets/images/f1.png" />
                          </div>
                          <div class="modalProDesc">
                                <h3>Neville Griffin</h3>
                                <p>@nevilleg</p>
                          </div>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/chat-details/1" class="profileModalItem" @click="msgModal==false">
                          <div class="modalProImg">
                                <img alt="commaful-logo" src="../../assets/images/f1.png" />
                          </div>
                          <div class="modalProDesc">
                                <h3>Neville Griffin</h3>
                                <p>@nevilleg</p>
                          </div>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/chat-details/1" class="profileModalItem" @click="msgModal==false">
                          <div class="modalProImg">
                                <img alt="commaful-logo" src="../../assets/images/f1.png" />
                          </div>
                          <div class="modalProDesc">
                                <h3>Neville Griffin</h3>
                                <p>@nevilleg</p>
                          </div>
                      </router-link>
                  </li>
              </ul>
            </div>
            <div slot="footer" class="import-btn">        
           
                
               
            </div>
        </modal>
        <!-- message modal end -->
  </div>
</template>

<script>
  import { EventBus } from '../../main';
  export default {

      name: "chat-sidebar",

      data() {
          return {
              activeItem: '',
              msgModal:false,
              window: {
                width: 0
              }
          }
      },

      methods: {
          showMsgModals() {
              this.msgModal=true;
          },

          reset(){
              this.importText='';
          },
          isActive (menuItem) {
            return this.activeItem === menuItem
          },
          setActive (menuItem) {
            this.activeItem = menuItem;
            localStorage.setItem('setActive',menuItem);
            EventBus.$emit('setActive', menuItem);
          },

          setActiveInSession(){
            if(localStorage.getItem('setActive')) {
              this.activeItem=localStorage.getItem('setActive');
            } else {
              this.activeItem='direct';
            }
          },

          // get device size
          handleResize() {
            this.window.width = window.innerWidth;
          }

      },

      destroyed() {
          window.removeEventListener('resize', this.handleResize)
      },



      created() {
        //window resize
         window.addEventListener('resize', this.handleResize)
         this.handleResize();
         this.setActiveInSession();
      },

  }
</script>




<style>

    @import '../../assets/css/chat-sidebar.css';

</style>